import styled from '@emotion/styled';
import { JockeyAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/JockeyAndTrainerDetails';
import { withConfig } from 'src/withConfig';

export const CellRunner = styled('div', { label: 'CellRunner' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 8px;
    justify-content: start;
    min-width: 120px;
    overflow: hidden;
    padding: 8px 12px;
`;

export const SilkCellRaceSummaryWrapper = styled('div', { label: 'SilkCellRaceSummaryWrapper' })`
    align-items: center;
    display: flex;
    flex: 0 0 36px;
    justify-content: center;
`;

export const JockeyAndTrainerDetailsBox = withConfig(theme => styled(JockeyAndTrainerDetails, { label: 'JockeyAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);


interface CellRunnerInfoWrapperType {
    isRasGoldActive: boolean;
}

export const CellRunnerInfoWrapper = withConfig(theme => styled('div', { label: 'CellRunnerInfoWrapper' })<CellRunnerInfoWrapperType>`
    align-items: start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    justify-content: center;
    overflow: hidden;
    padding-right: ${({ isRasGoldActive }): string => isRasGoldActive ? '32px' : '0'};
    position: relative;
    @media ${theme.star.mediaQuery.tablet} {
        align-items: center;
        flex-direction: row;
        gap: 8px;
    }
`);
